import { render } from "./ThankYouPage.vue?vue&type=template&id=d590500c"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__